import {Component} from '@angular/core';
import {NgControl} from '@angular/forms';
import {AbstractInput} from '../../abstracts/abstract-input';

@Component({
  selector: 'app-input-password',
  templateUrl: '../input-base/input-base.component.html'
})
export class InputPasswordComponent extends AbstractInput {
  constructor(public ngControl: NgControl) {
    super(ngControl);
  }
}
